import React, { Component } from 'react';
import { Row } from "antd";
import Table1 from './7-5-1';
import Table2 from './7-5-2';
import Chart from './components/Chart'

class index extends Component {
    render() {
        return (
            <div>
                <Table1></Table1>
                <Table2></Table2>
                <Chart />
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/7-HumanResourcesAnalysis/7-5/index.js